module.exports = __webpack_public_path__ + "img/732617.faf11073.jpg";